// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__zGZdy","sm":"Avatar_sm__C9Oix","md":"Avatar_md__Nbszh","lg":"Avatar_lg__OKNrw","img":"Avatar_img__6wl43","initials":"Avatar_initials__xyczk"};